export const scrollToId = (id) => {
  const target = document.querySelector(id);
  if (!target) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(target, { offset: -72, duration: 1.6 });
  } else {
    target.scrollIntoView({ behavior: "smooth" });
  }
};

export const IMAGES = {
  heroWater:
    "https://images.unsplash.com/photo-1555412654-72a95a495858?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwyfHxjYWxtJTIwd2F0ZXIlMjByaXBwbGVzJTIwdGVhbHxlbnwwfHx8fDE3ODgyNjgyOTd8MA&ixlib=rb-4.1.0&q=85",
  stillLake:
    "https://images.unsplash.com/photo-1439066615861-d1af74d74000?q=80&w=1600&auto=format&fit=crop",
  oceanWave:
    "https://images.unsplash.com/photo-1505118380757-91f5f5632de0?q=80&w=1600&auto=format&fit=crop",
  waveCrest:
    "https://images.unsplash.com/photo-1439405326854-014607f694d7?q=80&w=1600&auto=format&fit=crop",
  portrait: "/images/photo-3-hd.jpeg",
  portraitGarden: "/images/photo-2.jpeg",
  acbLogo: "/images/acb-logo.png",
};

export const CONTACT = {
  brand: "Yielding",
  brandSub: "Flow & Form",
  phone: "081 505 5429",
  phoneIntl: "+27815055429",
  whatsapp: "https://wa.me/27815055429",
  email: "ano@pawc.co.za",
  address: "21 Shepherd Ave, Bryanston, Johannesburg",
  practice: "Psychology and Wellness Centre (PAWC)",
  pawcDays: "Monday, Tuesday, Thursday, Friday and Saturday",
  witsDays: "Wednesdays",
  name: "Anoshamisa Clive Benhura",
  title: "Registered Counselling Psychologist",
  hpcsa: "PS 0166685",
  practiceNo: "1327410",
};
